import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { GLOBAL } from './global';
import 'rxjs/add/operator/map';

@Injectable()
export class RendimientoService {

  constructor(private http:HttpClient) {
   }

   get(){
     let url = `${GLOBAL.url}average`;
     return this.http.get(url).map((res)=>{
       return res;
     })
   }

   getDataFiltered(filters){
     let url = `${GLOBAL.url}average${filters}`;
     return this.http.get(url).map((res)=>{
       return res;
     })
   }

   createAverage(body){
     let url=`${GLOBAL.url}average`
     return this.http.post(url,body).map((res)=>{
       return res;
     });
   }

   editAverage(body,id){
     let url =`${GLOBAL.url}average/${id}`
     return this.http.put(url,body).map((res)=>{
       return res;
     })
   }

   getJsonCreate(lot_id,product_id,average,distribution){
     return `{"data":{
                        "attributes":{
                                      "lot_id":"${lot_id}",
                                      "product_id":"${product_id}",
                                      "average":"${average}",
                                      "distribution":"${distribution}"
                                     }
                      }
              }`;
   }

   getJsonEdit(id,average,distribution){
     return `{"data":{
                        "attributes":{
                            "id":"${id}",
                            "average":"${average}",
                            "distribution":"${distribution}"
                        }
                     }
     }`;
   }

}



// WEBPACK FOOTER //
// C:/Apache24/htdocs/ostimar/frontend/src/app/services/rendimiento.service.ts